import React from 'react'
import './BreadcrumBar.scss'

import { Typography } from '@material-ui/core'
import HomeIcon from '@mui/icons-material/Home'

import { Link } from 'react-router-dom'

const BreadcrumBar = () => (
    <div className="BreadcrumContainer" role="presentation" data-test-id="breadcrum-container">
        <ul className="breadcrumb medium separator-chevron">
            <li className="breadcrumb-item">
                <Link to="/" data-test-id="home_crum">
                    <HomeIcon /> Use Case List
                </Link>
            </li>
            <li className="breadcrumb-item">
                <a href="#">
                    <Typography>New Use Case</Typography>
                </a>
            </li>
        </ul>
    </div>
)

export default BreadcrumBar
